<template>
  <div ref="popup" class="alert alert-danger" role="alert" v-show="visible">
    <div v-html="pTextHtml"></div>
    <div>
      <button type="button" class="btn btn-default bs3-margin-right" @click="onCancel">{{ pCancelButtonText }}</button>
      <button type="button" class="btn btn-primary" @click="onConfirm">{{ pConfirmButtonText }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationAlert",
  props: {
    pTextHtml: String,
    pCancelButtonText: String,
    pConfirmButtonText: String
  },
  data: function () {
    return {
      visible: false,
      resolvePromise: undefined,
      rejectPromise: undefined,
    }
  },
  methods: {
    show()
    {
      this.visible = true;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    onConfirm()
    {
      this.visible = false;
      this.resolvePromise(true)
    },

    onCancel()
    {
      this.visible = false;
      this.resolvePromise(false)
    },
  }
}
</script>

<style scoped>

</style>